module.exports = __webpack_public_path__ + "img/consulta-ingreso-tardio.b6867403.png";